<ng-template #reportingManagerModal>
    <div class="modal-header">
        <h5 class="modal-title">{{ modalTitle }}</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.close()"></button>
    </div>

    <form [formGroup]="userReportingForm" (ngSubmit)="onSubmit()" autocomplete="off">
        <div class="modal-body">
            <div class="row g-3">

                <!-- Level -->
                <div class="col-12">
                    <label class="form-label fw-semibold">Reporting Level</label>
                    <select class="form-select" formControlName="levelId">
                        <option [ngValue]="null" disabled>Select Level</option>
                        <option *ngFor="let lvl of levelList" [ngValue]="lvl.key">
                            {{ lvl.value }}
                        </option>
                    </select>
                </div>

                <!-- Reporting Manager 1 -->
                <div class="col-12">
                    <label class="form-label fw-semibold">Reporting Manager 1</label>
                    <select class="form-select" formControlName="reportingManager1">
                        <option [ngValue]="null" disabled>Select Manager</option>
                        <option *ngFor="let mgr of managerList" [ngValue]="mgr.key">
                            {{ mgr.value }}
                        </option>
                    </select>
                </div>

                <!-- Reporting Manager 2 -->
                <div class="col-12">
                    <label class="form-label fw-semibold">Reporting Manager 2</label>
                    <select class="form-select" formControlName="reportingManager2">
                        <option [ngValue]="null" disabled>Select Manager</option>
                        <option *ngFor="let mgr of managerList" [ngValue]="mgr.key">
                            {{ mgr.value }}
                        </option>
                    </select>
                </div>

                <!-- Reporting Manager 3 -->
                <div class="col-12">
                    <label class="form-label fw-semibold">Reporting Manager 3</label>
                    <select class="form-select" formControlName="reportingManager3">
                        <option [ngValue]="null" disabled>Select Manager</option>
                        <option *ngFor="let mgr of managerList" [ngValue]="mgr.key">
                            {{ mgr.value }}
                        </option>
                    </select>
                </div>

            </div>



        </div>

        <div class="modal-footer">
            <button class="universal-submit-btn" type="submit"  [disabled]="isSubmitLoading">
             <span *ngIf="isSubmitLoading" class="spinner-border spinner-border-sm me-2"></span>
                {{ submitButtonText }}
            </button>
        </div>
    </form>
</ng-template>